module.exports = __webpack_public_path__ + "img/chat2-2.1ddf391f.png";